import { GET_ZONE, GET_AREA, GET_FACILITY_TYPE } from "../constants/type";
import Api from "../utils/api";
import { EndPoints } from "../constants/endpoints";
import { settings } from "../assets/settings";

export const getZones = () => {
    return (dispatch) => {
        return {
            type: GET_ZONE,
            payload: () => {
                return Api.get( EndPoints.zones() );
            }
        };
    };
}


export const getAreas = (param={}) => {
    return (dispatch) => {
        if( settings.zone_id != null ){
            param.zone_id = settings.zone_id;
        }
        return {
            type: GET_AREA,
            payload: () => {
                return Api.get( EndPoints.areas(), param );
            }
        };
    };
}


export const getTypes = (param={}) => {
    return (dispatch) => {
        if( settings.zone_id != null ){
            param.zone_id = settings.zone_id;
        }
        return {
            type: GET_FACILITY_TYPE,
            payload: () => {
                return Api.get( EndPoints.facility_types(), param );
            }
        };
    };
}
